import React, { Fragment, useRef, useState, useEffect } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getGifsSearch } from "../../../actions/gif";

import MentorModChatMessageItem from "../Mentors/MentorModChatMessageItem";
import GifItem from "../IME/GifItem";

const CampaignModChat = ({
  profile,
  auth: { user, isAuthenticated },
  modmessages,
  modmessage,
  setModMessage,
  deleteModMessage,
  TimeOutMod,
  timeoutDeleteModMessage,
  showModGIFs,
  setshowModGIFs,
  gifSearch,
  setModGifSearch,
  sendModMessage,
  gifs,
  setModGif,
  foundModGif,
  text,
  setModText,
  filterModText,
  setFilterModText,
  getGifsSearch,
  setShowModChat,
  setShowChat,
  timeoutUser,
  unTimeoutUser,
  setReportUserOpen,
  setShowReportUser,
  setReportedUser,
  moderators,
  deleteModerator,
  viewerCount,
  maxLength,
  setShowBanUser,
  setBannedUser,
  moderate,
  banDeleteMessage,
  Ban,
}) => {
  const inputRef = useRef(null);

  const [mention, setMention] = useState(false);

  const [str, setStr] = useState(" ");

  function checkWord(word) {
    word.split(" ").map((x) => {
      if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
        setMention(true);
      } else {
        setMention(false);
      }
    });
  }

  function addMention(e, modmessage) {
    let messageArray = modmessage.split(" ");
    messageArray.pop();
    messageArray.push(e.currentTarget.attributes.value.value);
    setModMessage(messageArray.join(" ").toString());
    setMention(false);
  }

  useEffect(() => {
    checkWord(modmessage);
  }, [modmessage]);

  useEffect(() => {
    modmessage.split(" ").map((x) => {
      if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
        setStr(x);
      }
    });
  }, [modmessage]);

  return (
    <Fragment>
      <div className="live-stream-side-container border-left grey">
        {user.channelid === "roland" && (
          <div className="container-name">
            <i
              className="far fa-window-close fa-2x red close-window"
              onClick={() => setShowModChat(false)}
            ></i>
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowModChat(true);
                setShowChat(false);
              }}
            >
              <i className="fas fa-users-cog red mr-5"></i>Mods
              <i className="far fa-check-circle red fa-sm mx-5"></i>
            </p>
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowChat(true);
                setShowModChat(false);
              }}
            >
              <i className="far fa-comments red mr-5"></i>Chat
            </p>
            <i className="fas fa-external-link-alt fa-lg red pop-out"></i>
          </div>
        )}
        {moderators &&
          moderators.length > 0 &&
          moderators.map((mod) => {
            if (mod.channelid === user.channelid) {
              return (
                <div className="container-name">
                  <i
                    className="far fa-window-close fa-2x red close-window"
                    onClick={() => setShowModChat(false)}
                  ></i>
                  <p
                    className="container-title cursor red"
                    onClick={() => {
                      setShowModChat(true);
                      setShowChat(false);
                    }}
                  >
                    <i className="fas fa-users-cog red mr-5"></i>Mods
                    <i className="far fa-check-circle red fa-sm mx-5"></i>
                  </p>
                  <p
                    className="container-title cursor red"
                    onClick={() => {
                      setShowChat(true);
                      setShowModChat(false);
                    }}
                  >
                    <i className="far fa-comments red mr-5"></i>Chat
                  </p>
                  <i className="fas fa-external-link-alt fa-lg red pop-out"></i>
                </div>
              );
            }
          })}
        {user.channelid === "roland" && (
          <div className="chat-search">
            <input
              type="text"
              className="gif-input"
              name="text"
              value={filterModText}
              onChange={(e) => setFilterModText(e.target.value)}
              placeholder="Search for messages..."
            />
            <i className="fas fa-search magnifying red fa-lg cursor"></i>
          </div>
        )}
        <ScrollToBottom className="all-content">
          {/* {modmessages.map((modmessage, index) => (
            <MentorModChatMessageItem
              key={index}
              user={user}
              modmessage={modmessage}
              modmessages={modmessages}
              deleteModMessage={deleteModMessage}
              TimeOutMod={TimeOutMod}
              timeoutDeleteModMessage={timeoutDeleteModMessage}
              profile={profile}
              isAuthenticated={isAuthenticated}
              timeoutUser={timeoutUser}
              unTimeoutUser={unTimeoutUser}
              setReportUserOpen={setReportUserOpen}
              moderators={moderators}
              deleteModerator={deleteModerator}
              setReportedUser={setReportedUser}
              setShowReportUser={setShowReportUser}
            />
          ))} */}
          {filterModText !== "" && modmessages && modmessages.length > 0
            ? modmessages
                .filter((modmessage) => {
                  return (
                    modmessage.firstname.toLowerCase().match(filterModText) ||
                    modmessage.text.toLowerCase().match(filterModText) ||
                    modmessage.firstname.match(filterModText) ||
                    modmessage.text.match(filterModText)
                  );
                })
                .map((modmessage, index) => {
                  return (
                    <MentorModChatMessageItem
                      key={index}
                      user={user}
                      modmessage={modmessage}
                      modmessages={modmessages}
                      deleteModMessage={deleteModMessage}
                      isAuthenticated={isAuthenticated}
                      profile={profile}
                      TimeOutMod={TimeOutMod}
                      setShowReportUser={setShowReportUser}
                      setReportedUser={setReportedUser}
                      setShowBanUser={setShowBanUser}
                      setBannedUser={setBannedUser}
                      moderators={moderators}
                      moderate={moderate}
                      deleteModerator={deleteModerator}
                      timeoutDeleteModMessage={timeoutDeleteModMessage}
                      banDeleteMessage={banDeleteMessage}
                      Ban={Ban}
                      timeoutUser={timeoutUser}
                      unTimeoutUser={unTimeoutUser}
                      setReportUserOpen={setReportUserOpen}
                    />
                  );
                })
            : modmessages &&
              modmessages.map((modmessage, index) => (
                <MentorModChatMessageItem
                  key={index}
                  user={user}
                  modmessage={modmessage}
                  modmessages={modmessages}
                  deleteModMessage={deleteModMessage}
                  isAuthenticated={isAuthenticated}
                  profile={profile}
                  TimeOutMod={TimeOutMod}
                  setShowReportUser={setShowReportUser}
                  setReportedUser={setReportedUser}
                  setShowBanUser={setShowBanUser}
                  setBannedUser={setBannedUser}
                  moderators={moderators}
                  moderate={moderate}
                  deleteModerator={deleteModerator}
                  timeoutDeleteModMessage={timeoutDeleteModMessage}
                  banDeleteMessage={banDeleteMessage}
                  Ban={Ban}
                  timeoutUser={timeoutUser}
                  unTimeoutUser={unTimeoutUser}
                  setReportUserOpen={setReportUserOpen}
                />
              ))}
        </ScrollToBottom>
        {user && user.role !== "employer" && (
          <div>
            <div className="comment-gif-input-hidden">
              {showModGIFs && foundModGif === "" && (
                <div className="giphy-container">
                  <div className="wrap-container">
                    <div className="powered-by-giphy red">Powered By</div>
                    <img
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Giphy_Logo.png"
                      }
                      style={{
                        width: "80px",
                        margin: "0px 10px",
                      }}
                      alt="logo"
                    />
                    <i
                      className="far fa-times-circle fa-lg red gif-x"
                      onClick={() => setshowModGIFs(false)}
                    ></i>
                  </div>
                  <div className="gifs" id="red-scroll">
                    {!gifSearch &&
                      gifs.map((gif) => (
                        <div
                          className="gif-choice"
                          onClick={(e) => {
                            setModGif(e.target.attributes["src"].value);
                            inputRef.current.focus();
                          }}
                        >
                          <GifItem key={gif.id} gif={gif} />
                        </div>
                      ))}
                    {gifSearch &&
                      gifs.map((gif) => (
                        <div
                          className="gif-choice"
                          onClick={(e) => {
                            setModGif(e.target.attributes["src"].value);
                            inputRef.current.focus();
                          }}
                        >
                          <GifItem key={gif.id} gif={gif} />
                        </div>
                      ))}
                  </div>
                  <form
                    className="gif-input-hidden"
                    onSubmit={(e) => {
                      e.preventDefault();
                      getGifsSearch({ text });
                      setModText("");
                      setModGifSearch(true);
                    }}
                  >
                    <input
                      type="text"
                      className="gif-input"
                      name="text"
                      value={text}
                      onChange={(e) => setModText(e.target.value)}
                      placeholder="Search for GIFs..."
                    />
                    <button
                      type="submit"
                      onSubmit={(e) => {
                        e.preventDefault();
                        getGifsSearch({ text });
                        setModText("");
                        setModGifSearch(true);
                        setshowModGIFs(false);
                      }}
                      className="gif-input-button background-red"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </form>
                </div>
              )}
            </div>
            {isAuthenticated && !user.banned && !user.timed_out && (
              <div className="chat-message-container">
                {gifs && foundModGif !== "" && (
                  <div className="selected-gif-container">
                    <div>
                      <img
                        className="selected-gif"
                        alt="gif-avatar"
                        src={gifs && foundModGif}
                      />
                      <i
                        className="far fa-times selected-gif-x"
                        onClick={() => {
                          setModGif("");
                          setshowModGIFs(false);
                        }}
                      ></i>
                    </div>
                  </div>
                )}
                {mention && (
                  <div className="room-users-container">
                    <div className="room-users-mini">
                      <ul>
                        {viewerCount &&
                          viewerCount
                            .filter((y) => {
                              return y.channelid.match(str.substring(1));
                            })
                            .map((c) => {
                              if (c.channelid !== "") {
                                return (
                                  <li
                                    onClick={(e) => {
                                      addMention(e, modmessage);
                                      inputRef.current.focus();
                                    }}
                                    className={`room-user-item ${
                                      c.role === "innovator"
                                        ? "green"
                                        : c && c.role === "mentor"
                                        ? "red"
                                        : c && c.role === "employer"
                                        ? "blue"
                                        : ""
                                    } bold`}
                                    value={`@${c.channelid}`}
                                  >
                                    @{c.channelid}
                                  </li>
                                );
                              }
                            })}
                      </ul>
                    </div>
                  </div>
                )}
                <div className="chat-input-hidden">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="chat-avi-user"
                    alt="avatar"
                  />
                  <input
                    className="chat-input"
                    type="text"
                    value={modmessage}
                    ref={inputRef}
                    onChange={(e) => setModMessage(e.target.value)}
                    maxLength={100}
                    onKeyPress={(e) => {
                      if (modmessage.length <= maxLength && e.key === "Enter") {
                        sendModMessage(e);
                      }
                    }}
                    placeholder="Type message here..."
                  />
                  {isAuthenticated &&
                    user.founding_supporter_type !== "Good" &&
                    user.founding_supporter_type !== "" && (
                      <div
                        className={`gif-button-container ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                        onClick={() => setshowModGIFs(true)}
                      >
                        <p className="gif-button">GIF</p>
                      </div>
                    )}
                  <p className="white character-counter-comment">
                    {modmessage.length}/{maxLength} characters
                  </p>
                </div>
              </div>
            )}
            {isAuthenticated && user.banned && (
              <div className="chat-message-container grey">
                <div className="user-banned red">
                  <i className="fa-solid fa-ban mr-5 fa-lg red"></i>Banned
                </div>
              </div>
            )}
            {isAuthenticated && user.timed_out && (
              <div className="chat-message-container grey">
                <div className="user-banned red">
                  <i className="fa-solid fa-clock mr-5 fa-lg red"></i>
                  Timed Out
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};

CampaignModChat.propTypes = {
  auth: PropTypes.object.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gif: state.gif,
});

export default connect(mapStateToProps, { getGifsSearch })(CampaignModChat);
